<div class="mb-4">
  <p-button label=" Download Template" (click)="downloadTemplate()" />
</div>
<!-- <p-fileUpload
  #fileUpload
  name="file"
  (uploadHandler)="onUpload($event)"
  (onClear)="onClose()"
  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  [customUpload]="true"
  [auto]="true"
  mode="advanced"
  class="jni-fileupload-hide-file">
  <ng-template
    pTemplate="content"
    let-files
    let-chooseCallback="chooseCallback"
    let-uploadCallback="uploadCallback">
    <div
      class="po-attachment-drag-drop-container"
      (dragover)="onDragOver($event)"
      (drop)="onFileDrop($event)"
      (dragleave)="onDragLeave($event)"
      (dragenter)="onDragEnter($event)">
      <div class="po-attachment-drag-drop-area" [class.drag-over]="isDragOver">
        <i class="pi pi-cloud-upload po-attachment-drag-drop-icon"></i>
        <div class="po-attachment-drag-drop-text">
          <p class="mb-2">Drag & Drop files here</p>
        </div>
      </div>
      <div *ngIf="uploadedFiles.length" class="uploaded-files-list mt-3">
        <h6>Uploaded Files:</h6>
        <ul>
          <li *ngFor="let file of uploadedFiles" class="text-success">
            {{ file.name }} - {{ formatFileSize(file.size) }}
          </li>
        </ul>
      </div>
    </div>
  </ng-template>
</p-fileUpload> -->
<p-fileUpload
  #workflowFileUpload
  name="file"
  (uploadHandler)="onUpload($event)"
  (onClear)="clearUploadFile()"
  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  [customUpload]="true"
  class="jni-fileupload-hide-files">
  <ng-template
    pTemplate="content"
    let-files
    let-chooseCallback="chooseCallback">
    <div
      class="po-attachment-drag-drop-container"
      (dragover)="onDragOver($event)"
      (drop)="onFileDrop($event)"
      (dragleave)="onDragLeave($event)"
      (dragenter)="onDragEnter($event)">
      <div class="po-attachment-drag-drop-area" [class.drag-over]="isDragOver">
        <i class="pi pi-cloud-upload po-attachment-drag-drop-icon"></i>
        <div class="po-attachment-drag-drop-text">
          <p class="mb-2">Drag & Drop files here</p>
        </div>
      </div>
      <div
        *ngIf="files && files.length > 0"
        class="po-attachment-files-preview mt-2">
        <div
          *ngFor="let file of files"
          class="po-attachment-file-item d-flex align-items-center p-2 border rounded mb-1">
          <i class="pi pi-file text-primary me-2"></i>
          <div class="flex-grow-1">
            <div class="font-weight-bold small">{{ file.name }}</div>
            <div class="text-muted small">
              {{ formatFileSize(file.size) }}
            </div>
          </div>
          <p-button
            icon="pi pi-times"
            (click)="removeFile()"
            class="p-button-text p-button-sm">
          </p-button>
        </div>
      </div>
    </div>
  </ng-template>
</p-fileUpload>
